import { render, staticRenderFns } from "./audio-player.vue?vue&type=template&id=6cf750ce&scoped=true"
import script from "./audio-player.vue?vue&type=script&lang=ts"
export * from "./audio-player.vue?vue&type=script&lang=ts"
import style0 from "./audio-player.vue?vue&type=style&index=0&id=6cf750ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf750ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
